// extracted by mini-css-extract-plugin
export default {"container":"languageMenu-module--container--CxWRB","content":"languageMenu-module--content--3sVrl"};